import { render, staticRenderFns } from "./StudentAddonProgrammePartner.vue?vue&type=template&id=68baf1d6&scoped=true"
import script from "./StudentAddonProgrammePartner.vue?vue&type=script&lang=js"
export * from "./StudentAddonProgrammePartner.vue?vue&type=script&lang=js"
import style0 from "./StudentAddonProgrammePartner.vue?vue&type=style&index=0&id=68baf1d6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "68baf1d6",
  null
  
)

export default component.exports